import './ShowHeader.scss';

import { DateField } from '@refinedev/antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface ShowHeaderProps {
  title: ReactNode;
  className?: string;
  /** Tag principal del registro (estado, etc.). */
  statusTag?: ReactNode;
  /** Tags secundarios junto al statusTag (ej: "Automática"); misma estética de píldora. */
  extraTags?: ReactNode;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: ReactNode;
}

/**
 * Encabezado estándar de pantallas Show: id/título + tags de estado a la
 * izquierda, metadata (fechas, creado por) a la derecha.
 * @param props.title Título/identificador del registro (ej: "Orden de servicio #123").
 * @param props.statusTag Tag de estado principal, destacado visualmente.
 * @param props.extraTags Tags secundarios, sin destacar.
 * @param props.createdAt Fecha de creación del registro.
 * @param props.updatedAt Fecha de última modificación del registro.
 * @param props.createdBy Texto/nodo describiendo quién creó el registro.
 */
export const ShowHeader = (props: ShowHeaderProps) => {
  const { title, className, statusTag, extraTags, createdAt, updatedAt, createdBy } = props;
  const { t } = useTranslation();
  const hasTags = statusTag != undefined || extraTags != undefined;
  const hasMetadata = createdAt != undefined || updatedAt != undefined || createdBy != undefined;

  return (
    <div className={`ShowHeader ${className || ''}`}>
      <div className="ShowHeaderId">
        <b>{title}</b>
        {hasTags && (
          <div className="ShowHeaderTags">
            {statusTag}
            {extraTags}
          </div>
        )}
      </div>
      {hasMetadata && (
        <div className="ShowHeaderMetadata">
          {createdAt && (
            <div>
              <b>{t('Fecha de creación')}: </b>
              <DateField value={createdAt} />
            </div>
          )}
          {updatedAt && (
            <div>
              <b>{t('Fecha última modificación')}: </b>
              <DateField value={updatedAt} />
            </div>
          )}
          {createdBy && (
            <div>
              <b>{t('Creado por')}: </b>
              {createdBy}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ShowHeader;
